module.exports = __webpack_public_path__ + "static/media/Sims Floyd Headshot.73ee250a.png";